export const STALE_THRESHOLD_MINUTES = 5
